<template>
  <v-app>
    <v-navigation-drawer
      v-model="drawerham"
      heigh="100vh"
      app
      fixed
      temporary
      color="black"
      location="end"
      :style="{ opacity: drawerham ? drawerOpacity : '0!important', visibility: drawerham ? 'visible!important' : 'hidden!important' }"
      @input="handleDrawerInput"
      :class="classNavigation"
    >
      <v-container class="container-size-drawer">
        <v-row justify="center" style="padding-left: 12px;padding-top:12px;">
       
            <span class="font-logos" v-if="isfullScreen" @click="handleClickMenu('42Monks')" style="cursor: pointer; opacity:1; font-size: 18px; padding-top: 8px; padding-left:8px;">42MONKS CAPITAL</span>

            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-btn v-if="!isfullScreen" @click="closeDrawer()" color="black" text plain :ripple="false" class="menu-btn-close text-none">
              Close
            </v-btn>
            <v-btn v-if="isfullScreen" @click="closeDrawer()" color="black" text plain :ripple="false" class="menu-btn-close text-none" style="margin-bottom:6px" >
              Close
            </v-btn>
        </v-row>
          <v-list
            nav
            dense   
            :class="{ 'mt-15': !(this.isMobile && this.isMobileXs)}" 
            :style="{ 'margin-top': drawermargin }"  
            >
              <v-divider style="opacity: 1;" class="pb-5"></v-divider>
              <v-row style="cursor:pointer" @click="handleClickMenu('About')" justify="start">
                <v-btn color="black" text plain :ripple="false" class="menu-btn-close2 text-none" style="margin-bottom:6px">
                  About
                </v-btn>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-icon icon="mdi-arrow-right-thin" class="mdi-24px icon-exp-sub"></v-icon>
              </v-row>
              <v-divider style="opacity: 1;" class="pb-5 mt-4"></v-divider>
              <v-row style="cursor:pointer" justify="start">
                <v-expansion-panels>
                  <v-expansion-panel class="panel-expansion">
                    <v-expansion-panel-title class="title-expansion" expand-icon="mdi-plus" collapse-icon="mdi-minus">
                      <v-btn color="black" text plain :ripple="false" class="menu-btn-close2 text-none" style="margin-bottom:6px" >
                        Products
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-spacer></v-spacer>
                      <v-spacer></v-spacer>
                    </v-expansion-panel-title>
                    <v-expansion-panel-text class="title-text">
                      <v-row style="cursor:pointer" justify="start" class="ma-0 pa-0">
                        <v-btn color="black" text plain :ripple="false" class="menu-btn-close2 text-none" style="margin-bottom:6px" @click="handleClickMenu('FamilyOffice')">
                          Family Office
                        </v-btn>
                      </v-row>
                      <v-row style="cursor:pointer" justify="start" class="ma-0 pa-0">
                        <v-btn color="black" text plain :ripple="false" class="menu-btn-close2 text-none" style="margin-bottom:6px" @click="handleClickMenu('FortyTwo')">
                          Generational Wealth Management
                        </v-btn>
                      </v-row>
                      <v-row style="cursor:pointer" justify="start" class="ma-0 pa-0">
                        <v-btn color="black" text plain :ripple="false" class="menu-btn-close2 text-none" style="margin-bottom:6px" @click="handleClickMenu('Quant')">
                          Quantitative Trading
                        </v-btn>
                      </v-row>
                    </v-expansion-panel-text>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-row>
              <v-divider style="opacity: 1;" class="pb-5 mt-4"></v-divider>
              <v-row style="cursor:pointer" @click="handleClickMenu('Office')" justify="start">
                <v-btn color="black" text plain :ripple="false" class="menu-btn-close2 text-none" style="margin-bottom:6px" >
                  Family Office
                </v-btn>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-icon icon="mdi-arrow-right-top" class="mdi-18px icon-exp-sub"></v-icon>
              </v-row>
              <v-divider style="opacity: 1;" class="pb-5 mt-4"></v-divider>
                <v-row style="cursor:pointer" @click="handleClickMenu('Log')" justify="start">
                <v-btn color="black" text plain :ripple="false" class="menu-btn-close2 text-none" style="margin-bottom:6px" >
                  Log in 
                </v-btn>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-icon icon="mdi-arrow-right-top" class="mdi-18px icon-exp-sub"></v-icon>
              </v-row>
              <v-divider style="opacity: 1;" class="pb-5 mt-4"></v-divider>
          </v-list>
          <v-row justify="center" style="padding-top:12px;padding-bottom:4px;">
            <LogoWhite @click="handleClickMenu('42Monks')" style="margin-left: 0px; min-height: 120px;"></LogoWhite>
          </v-row>
          <v-row justify="center" style="padding-bottom:4px;">
            <span class="font-logos" style="opacity:0.7; font-size: 14px;">PRIVATE WEALTH MANAGEMENT</span>
          </v-row>
          <v-row justify="center" style="padding-bottom:4px;">
            <span class="font-logos" style="opacity:0.7; font-size: 14px;">42Monks Capital, Monaco</span>
          </v-row>
          <v-row justify="center" style="padding-bottom:12px;">
            <span class="font-logos" style="opacity:0.7; font-size: 14px;">74 Boulevard d'Italie, Monte Carlo 98000</span>
          </v-row>
      </v-container>
    </v-navigation-drawer>

    <v-main id="parent-civ">
        <router-view v-slot="{ Component }" :drawerham="drawerham" :class="{'disable-scroll': drawerham }">
          <Transition name="fade" mode="out-in">
            <component :is="Component"/>
          </Transition>
        </router-view>
    </v-main>
  </v-app>
</template>

<script>

import { useMobile } from './composables/useMobile.js'
import { useMobileXs } from './composables/useMobileXs.js'
import LogoWhite from '@/components/logo_white.vue'

export default {
  setup() {
    const isMobile = useMobile()
    const isMobileXs = useMobileXs()

    return { isMobile, isMobileXs }
  },
  name: 'App',

  components: {
    LogoWhite
  },

  data: () => ({
    drawerham: false,
    drawerOpacity: 0,
    drawermargin: '54px',
  }),
  mounted() {   

  },
  created() {
    this.emitter.on('hamburger',  () => {
            this.drawerham = !this.drawerham;
            if (this.drawerham) {
              this.changeOpacityOnOpen();
            } else {
              this.changeOpacityOnClose();
            }
    })
  },
  computed: {
    classNavigation() {
      if(this.isMobile && this.isMobileXs){
        return 'navigationMobile';
      } else return 'navigationStandard';
    },
    isfullScreen(){
      if(this.isMobile && this.isMobileXs){
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    handleDrawerInput(value) {
    if (value) {
      this.changeOpacityOnOpen();
    } else {
      this.changeOpacityOnClose();
    }
    },
    changeOpacityOnOpen() {
      this.drawerOpacity = 1; 
    },
    changeOpacityOnClose() {
      this.drawerOpacity = 0; 
    },
    closeDrawer(){
      this.drawerham = false;
      this.drawerOpacity = 0;
    },
    handleClickMenu(link){
      if (link === 'Office'){
        window.open('https://office.42monks.com/','_blank');
      } else if (link === 'Log') {
        window.open('https://selene.42monks.com/','_blank');
      } else {
        if (this.$route.name !== link ) {
          this.$router.push({ name: link });
        }
      }
    }
  },
  watch: {
      '$route':{ 
        handler: (to, from) => { 
          document.title = to.meta.title || '42Monks Capital'
        },
         immediate: true         
      }
    }
}
</script>

<style>

.font-logos {
  font-family: "Anaktoria", sans-serif!important;
}

input:-webkit-autofill,
  input:-webkit-autofill:focus {
    transition: background-color 0s 600000s, color 0s 600000s !important;
  }

.disable-scroll {
  overflow: hidden!important; /* Hide vertical scrollbar */
}

#app {
  -webkit-font-smoothing: antialiased!important;
  -moz-osx-font-smoothing: grayscale!important;
  font-family: "Darker Grotesque", sans-serif!important;
}

.v-row {
  margin-right: 0px!important;
}

#body {
  background-color: transparent!important;
  text-rendering: optimizeLegibility!important;
}

#parent-civ {
    position: relative!important;
    background-color: transparent!important;
    padding-top: 0px!important;
    padding:0 !important;
    margin:0 !important;
}

.navigationStandard {
  position: fixed!important; 
  top:0!important;
  min-width: 400px!important;
  padding: 0!important;
  margin: 0!important;
  transition-duration: 0.15s!important;
  transition-property: opacity!important;
  transition-timing-function: ease-in-out!important;
}

.navigationMobile {
  position: fixed!important; 
  min-width: 100vw!important;
  transition-duration: 0.15s!important;
  transition-property: opacity!important;
  transition-timing-function: ease-in-out!important;
}

.container-size-drawer {
  padding-right: 22px!important;
  padding-left: 22px!important;
}


.menu-btn-close {
  color: white!important;
  font-family: "Darker Grotesque", sans-serif!important;
  font-weight: bold!important;
  font-size: 18px!important;
  transition: none !important;
  margin-left: 10px!important;
  padding-left: 2px!important;
  margin-right: 10px!important;
  padding-right: 2px!important;
  background-color: transparent!important;
}

.menu-btn-close:hover {
  color: white!important;
  background-color: transparent!important;
  transition: none!important;
}


.menu-btn-close:hover .v-btn__overlay {
  background-color: transparent!important;
}

.menu-btn-close .v-btn__overlay{
  background-color: transparent!important; 
  opacity: 0!important;
}

.menu-btn-close2 .v-btn__overlay{
  background-color: transparent!important; 
  opacity: 0!important;
}

.menu-btn-close:hover::after .v-btn__overlay{
  background-color: red!important; 
  opacity: 0!important;
}

.menu-btn-close::before {
  content: ""!important;
  position: absolute!important;
  left: 5px!important;
  top: 34px!important;
  width: 85%!important; 
  height: 1px!important; 
  background-color: white!important; 
  opacity: 0!important; 
}

.menu-btn-close:hover::before {
  opacity: 1!important; 
}

.menu-btn-close2 {
  color: white!important;
  font-family: "Darker Grotesque", sans-serif!important;
  font-weight: bold!important;
  font-size: 18px!important;
  transition: none !important;
  margin-left: 15px!important;
  padding-left: 2px!important;
  margin-right: 15px!important;
  padding-right: 2px!important;
  background-color: transparent!important;
  min-width: 0!important;
}

.menu-btn-close2:hover {
  color: white!important;
  background-color: transparent!important;
  transition: none!important;
}

.menu-btn-close2:hover .v-btn__overlay {
  background-color: transparent!important;
}

.menu-btn-close2::before {
  content: ""!important;
  position: absolute!important;
  left: 0px!important;
  top: 30px!important;
  width: 100%!important; 
  height: 1px!important; 
  background-color: white!important; 
  opacity: 0!important; 
}

.menu-btn-close2:hover::before {
  opacity: 1!important; 
}

.title-expansion {
  background-color: black!important;
  color: white!important;
  padding: 0!important;
  min-height: 0!important;
}

.title-text {
  background-color: black!important;
  color: white!important;
}

.panel-expansion {
  background-color: black!important;
}

.v-expansion-panel-title__overlay {
  background-color: black!important;
}

.v-expansion-panel-title__icon {
  padding-right: 12px!important;
}

.icon-exp-sub {
  color:white!important;
  padding:0!important;
  margin:0!important;
  padding-right:20px!important;
  padding-top:14px!important;
  opacity:1!important;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s ease!important;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0!important;
}

.text-head {
  font-size: 32px!important;
  line-height: 0.9!important;
  font-weight: 500!important;

  @media (min-width: 600px) {
    font-size: 38px!important;
    font-weight: 500!important;
    line-height: 0.9!important;
  }

  @media (min-width: 1280px) {
    font-size: 48px!important;
    font-weight: 500!important;
    line-height: 0.9!important;
  }
}

.fonts-desc {
  font-family: "Darker Grotesque", sans-serif!important;
  font-size: 20px!important;
  font-weight: 500!important;
  color: white;
  word-spacing: normal!important;
  line-height: 1!important;
  display: inline-block!important;

  @media (min-width: 600px) {
    font-size: 22px!important;
  }

  @media (min-width: 1280px) {
    font-size: 24px !important;
  }
}

.fonts-nb {
  font-family: "Darker Grotesque", sans-serif!important;
  font-size: 24px!important;
  font-weight: 400!important;
  color: white;

  @media (min-width: 600px) {
    font-size: 30px!important;
  }

  @media (min-width: 1280px) {
    font-size: 34px !important;
  }
}


.fonts {
  font-family: "Darker Grotesque", sans-serif!important;
  font-size: 24px!important;
  color: white;

  @media (min-width: 600px) {
    font-size: 30px!important;
  }

  @media (min-width: 1280px) {
    font-size: 34px !important;
  }
}

.fonts-small {
  font-family: "Darker Grotesque", sans-serif!important;
  font-size: 20px!important;

  @media (min-width: 600px) {
    font-size: 26px!important;
  }

  @media (min-width: 1280px) {
    font-size: 30px !important;
  }
}

.font2-small {
  font-family: "Cormorant Garamond", serif!important;
  font-weight: 500!important;
  font-size: 20px!important;

  @media (min-width: 600px) {
    font-size: 26px!important;
  }

  @media (min-width: 1280px) {
    font-size: 30px !important;
  }
}

.font2-head {
  font-family: "Cormorant Garamond", serif!important;
  font-weight: 600!important;
  font-size: 24px!important;

  @media (min-width: 600px) {
    font-size: 28px!important;
  }

  @media (min-width: 1280px) {
    font-size: 31px !important;
  }
}

.font2-heada {
  font-family: "Anaktoria", sans-serif!important;
  font-weight: 500!important;
  font-size: 24px!important;

  @media (min-width: 600px) {
    font-size: 28px!important;
  }

  @media (min-width: 1280px) {
    font-size: 31px !important;
  }
}

.font3-head {
  font-family: "Cormorant Garamond", serif!important;
  font-weight: 500!important;
  font-size: 30px!important;
  font-style: italic!important;
  word-spacing: normal!important;
  line-height: 1!important;


  @media (min-width: 600px) {
    font-size: 36px!important;
  }

  @media (min-width: 1280px) {
    font-size: 51px !important;
  }
}

.font3-heada {
  font-family: "Anaktoria", serif!important;
  font-weight: 400!important;
  font-size: 30px!important;
  font-style: italic!important;
  word-spacing: normal!important;


  @media (min-width: 600px) {
    font-size: 36px!important;
  }

  @media (min-width: 1280px) {
    font-size: 41px !important;
  }
}

.font4-head {
  font-family: "Cormorant Garamond", serif!important;
  font-weight: 500!important;
  font-size: 30px!important;
  word-spacing: normal!important;
  line-height: 1!important;


  @media (min-width: 600px) {
    font-size: 36px!important;
  }

  @media (min-width: 1280px) {
    font-size: 51px !important;
  }
}


.font2 {
  font-family: "Cormorant Garamond", serif!important;
  font-weight: 500!important;
  font-size: 24px!important;

  @media (min-width: 600px) {
    font-size: 30px!important;
  }

  @media (min-width: 1280px) {
    font-size: 34px !important;
  }
}

.container {
    width: 100%!important;
    margin-right: auto;
    margin-left: auto;

  @media (min-width: 600px) {
    width: 100%!important;
  }

  @media (min-width: 1280px) {
    width: 1625px!important;
  }
}

.textVideo {
  position: absolute!important;
  bottom: 0!important;
  margin-left: auto!important;
  margin-right: auto!important;
  width: 100%!important;
}

.textPanel {
  margin-left: auto!important;
  margin-right: auto!important;

}

.videoMargins {
  margin-left: 0px!important;
  margin-right: 0px!important;
  
  @media (min-width: 1280px) {
    margin-left: 230px!important;
    margin-right: 230px!important;
  }
}

.videoMargins2 {
  margin-left: 20px!important;
  margin-right: 20px!important;
  
  @media (min-width: 1280px) {
    margin-left: 20px!important;
    margin-right: 20px!important;
  }
}

.divider {
  max-height: 2px!important; 
  height: 2px!important; 
  color:white!important;
  opacity:0.9!important;
  padding-bottom:12px!important;
}

.dividerxs {
  max-height: 2px!important; 
  height: 2px!important; 
  color:white!important;
  opacity:0.9!important;
  padding-bottom:6px!important;
}

.btn-wrap-text {
  max-width: 100%!important;
  display: inline-block!important;
  line-height: 1.1!important;
}

.btn-wrap-text:hover {
  text-decoration: underline!important;
  cursor: pointer!important;
  text-decoration-thickness: 1px!important;
  text-underline-offset: 3px!important;
}

.fonts-xsmall {
  font-family: "Darker Grotesque", sans-serif!important;
  font-weight: 600!important;
  font-size: 22px!important;
  word-spacing: normal!important;

  @media (min-width: 600px) {
    font-size: 22px!important;
  }

  @media (min-width: 1280px) {
    font-size: 22px !important;
  }
}

.fonts-xsmall2 {
  font-family: "Darker Grotesque", sans-serif!important;
  font-weight: 500!important;
  font-size: 22px!important;
  word-spacing: normal!important;
  line-height: 1!important;

  @media (min-width: 600px) {
    font-size: 22px!important;
  }

  @media (min-width: 1280px) {
    font-size: 22px !important;
  }
}

.fonts-xsmall3 {
  font-family: "Darker Grotesque", sans-serif!important;
  font-weight: 500!important;
  font-size: 20px!important;
  word-spacing: normal!important;
  line-height: 1!important;

  @media (min-width: 600px) {
    font-size: 22px!important;
  }

  @media (min-width: 1280px) {
    font-size: 22px !important;
  }
}

.fonts-xsmall-date {
  font-family: "Darker Grotesque", sans-serif!important;
  font-weight: 500!important;
  font-size: 18px!important;
  word-spacing: normal!important;
  line-height: 1.1!important;

  @media (min-width: 600px) {
    font-size: 18px!important;
  }

  @media (min-width: 1280px) {
    font-size: 18px!important;
  }
}

.image-container:hover {
  cursor: pointer!important;
}

.image-container:hover .image-link {
  cursor: pointer!important;
}

.image-container:hover .btn-wrap-text {
  text-decoration: underline!important;
  cursor: pointer!important;
  text-decoration-thickness: 1px!important;
  text-underline-offset: 3px!important;
}

.page-top {
  margin-top: 0px!important;
  padding-top: 40px!important;
}

.page-bottom {
  padding-bottom: 30px!important;
}

</style>
